export default "__VITE_ASSET__CPVVGtcK__"